// The location list carries annual area metadata, not full financial year rows.
// Keep its current area data, but never let it replace a matching summary's
// contractual/net anchors. A summary for another lease must not be borrowed.
export function selectLeaseDetail(primaryLease, leases, selectedLeaseId) {
  const listed = leases.find((lease) => lease.id === selectedLeaseId);
  if (primaryLease?.id === selectedLeaseId) {
    return {
      ...primaryLease,
      ...listed,
      computed: primaryLease.computed,
      yearCosts: primaryLease.yearCosts,
      rentSchedule: primaryLease.rentSchedule,
      monthlyCosts: primaryLease.monthlyCosts,
      monthlyCostsStatus: primaryLease.monthlyCostsStatus,
      // The list supplies current area metadata, but a summary-only refresh
      // must not lose its narrative to an older copy in that list.
      aiSummary: primaryLease.aiSummary,
      aiSummaryAt: primaryLease.aiSummaryAt,
      aiSummarySource: primaryLease.aiSummarySource,
    };
  }
  return listed ?? primaryLease ?? null;
}
